"use strict";

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.number.parse-int");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.assign");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));
/* tslint:disable */


exports["default"] = function (_a) {
  var _b = _a.width,
      width = _b === void 0 ? '32px' : _b,
      _c = _a.height,
      height = _c === void 0 ? '32px' : _c,
      _d = _a.color,
      color = _d === void 0 ? '#000' : _d,
      _e = _a.bgColor,
      bgColor = _e === void 0 ? '#FFF' : _e,
      rest = __rest(_a, ["width", "height", "color", "bgColor"]);

  return react_1["default"].createElement("svg", __assign({}, rest, {
    width: width,
    height: height,
    viewBox: "0 0 " + Number.parseInt(width) + " " + Number.parseInt(height)
  }), react_1["default"].createElement("g", {
    stroke: 'none',
    fill: 'none',
    strokeWidth: '1',
    fillRule: 'evenodd',
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  }, react_1["default"].createElement("g", {
    transform: 'translate(-360.000000, -2610.000000)',
    stroke: '#064650'
  }, react_1["default"].createElement("g", {
    transform: 'translate(360.000000, 2609.000000)'
  }, react_1["default"].createElement("g", {
    transform: 'translate(0.000000, 1.000000)'
  }, react_1["default"].createElement("path", {
    d: 'M10,31.3333333 L3.33333333,31.3333333 C1.860574,31.3333333 0.666666667,30.139426 0.666666667,28.6666667 L0.666666667,3.33333333 C0.666666667,1.860574 1.860574,0.666666667 3.33333333,0.666666667 L16.6666667,0.666666667 C18.139426,0.666666667 19.3333333,1.860574 19.3333333,3.33333333 L19.3333333,15.3333333'
  }), react_1["default"].createElement("path", {
    d: 'M19.3333333,6 L0.666666667,6'
  }), react_1["default"].createElement("path", {
    d: 'M10,26 L0.666666667,26'
  }), react_1["default"].createElement("path", {
    d: 'M7.33333333,3.33333333 L12.6666667,3.33333333'
  }), react_1["default"].createElement("path", {
    d: 'M12.6666667,22 L31.3333333,22'
  }), react_1["default"].createElement("path", {
    d: 'M20.6666667,24.6666667 L15.3333333,24.6666667'
  }), react_1["default"].createElement("path", {
    d: 'M28.6666667,24.6666667 L26,24.6666667'
  }), react_1["default"].createElement("path", {
    d: 'M18,27.3333333 L15.3333333,27.3333333'
  }), react_1["default"].createElement("rect", {
    x: '12.6666667',
    y: '18',
    width: '18.6666667',
    height: '13.3333333',
    rx: '2'
  }), react_1["default"].createElement("path", {
    d: 'M8.14533333,16.8 C8.14533333,17.8243041 8.97569588,18.6546667 10,18.6546667 C11.0243041,18.6546667 11.8546667,17.8243041 11.8546667,16.8 C11.8546667,15.7756959 11.0243041,14.9453333 10,14.9453333 C8.97569588,14.9453333 8.14533333,14.1149708 8.14533333,13.0906667 C8.14533333,12.0663626 8.97569588,11.236 10,11.236 C11.0243041,11.236 11.8546667,12.0663626 11.8546667,13.0906667'
  }), react_1["default"].createElement("path", {
    d: 'M10,18.656 L10,19.8906667'
  }), react_1["default"].createElement("path", {
    d: 'M10,10 L10,11.2373333'
  }))))));
};
/* tslint:enable */